import React, { useState } from "react";
import TextField from "../TextField/TextField";
import { TabType } from "../../../services/helpers/types";
import { useTranslation } from "react-i18next";

interface EditTabProps {
  tab?: TabType;
  onChange: (name: string, value: string) => void;
}

const EditTab = (props: EditTabProps) => {
  const { tab, onChange } = props;

  const { t } = useTranslation();

  const [name, setName] = useState(tab?.name ?? "");
  const [value, setValue] = useState(tab?.value ?? "");

  const handleNameChange = (newName: string) => {
    setName(newName);
    onChange(newName, value);
  };
  const handleValueChange = (newValue: string) => {
    setValue(newValue);
    onChange(name, newValue);
  };

  return (
    <div className="dui-edit-tab">
      <div>{t("tabName")}:</div>
      <TextField value={name} onChange={handleNameChange} />
      <div>{t("valueThatWillBeDisplayed")}:</div>
      <TextField value={value} onChange={handleValueChange} />
    </div>
  );
};

export default EditTab;
